<template>
  <div id="app">
    <!-- <keep-alive :include="keepAlive"> https://open-apis.ponhu.cn/ -->
    <transition>
      <router-view/>
    </transition>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      isHasHeader: false
    }
  },
  mounted () {
  }
}
</script>
<style lang="less">
*{
  user-select:none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
/*iphoneX*/
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .van-tabbar--fixed{
          padding-bottom: 10px !important;
          padding-bottom: constant(safe-area-inset-bottom);
          padding-bottom: env(safe-area-inset-bottom);
      }
}
/*iphoneX Max*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .van-tabbar--fixed{
          padding-bottom: 10px !important;
          padding-bottom: constant(safe-area-inset-bottom);
          padding-bottom: env(safe-area-inset-bottom);
      }
}
</style>
